<section id="home" class="slider_area">
    <div id="carouselThree" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
            <li data-target="#carouselThree" data-slide-to="0" class="active"></li>


        </ol>
        <div class="carousel-inner">

            <div class="carousel-item active">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-7">
                            <div class="slider-content">
                                <h1 class="title">{{ 'SOLUTION6.TITLE' | translate }}</h1>
                                <div class="text">
                                    {{ 'SOLUTION6.TITLE_DESCRIPTION' | translate }}
                                </div>
                                <div class="slider-buttons">
                                    <div class="button-wrap">
                                        <a href="https://admin.propero.io/" target="_blank" class="btn primary-btn">
                                            Propero Assistant
                                        </a>
                                        <span i18n="@@mainSubtitleAdditionalText" class="btn-subtext">
                                            {{ 'HOME.MAIN_SUBTITLE_ADDITIONAL_TEXT' | translate }}
                                        </span>
                                    </div>

                                    <div class="button-wrap">
                                        <a routerLink="/solution-personalised" class="btn secondary-btn"
                                            i18n="@@mainPersonalizedOffer">
                                            {{ 'HOME.MAIN_PERSONALIZED_OFFER' | translate }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="slider-image">
                                <img src="assets/images/slider/2.png" alt="Hero">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <a class="carousel-control-prev" href="#carouselThree" role="button" data-slide="prev">
            <i class="lni lni-arrow-left"></i>
        </a>
        <a class="carousel-control-next" href="#carouselThree" role="button" data-slide="next">
            <i class="lni lni-arrow-right"></i>
        </a>
    </div>
</section>


<section id="features" class="features-area">
    <div class="container">
        <div class="section-title">
            <h3 class="title">{{'SOLUTION6.TITLE' | translate }}</h3>
            <p class="text">{{'SOLUTION6.TITLE_DESCRIPTION' | translate }}</p>
        </div>

        <div class="features-grid">
            <div class="feature-widget">
                <div class="widget-header">
                    <div class="widget-icon">
                        <i class="lni lni-apartment"></i>
                    </div>
                    <h4 class="widget-title">
                        {{'SOLUTION6.FEATURE_1_SHORT_TITLE' | translate }}
                    </h4>
                </div>
                <div class="widget-content">
                    <p class="widget-text">
                        {{'SOLUTION6.FEATURE_1_SHORT_TEXT' | translate }}
                    </p>
                    <div class="features-btn-wrapper">
                        <a (click)="scrollToFeature(1)" class="features-btn">
                            <i class="lni lni-arrow-right"></i>
                            {{'SOLUTION_GENERAL.DETAILS' | translate }}
                        </a>
                    </div>
                </div>
            </div>

            <div class="feature-widget">
                <div class="widget-header">
                    <div class="widget-icon">
                        <i class="lni lni-calculator"></i>
                    </div>
                    <h4 class="widget-title">
                        {{'SOLUTION6.FEATURE_2_SHORT_TITLE' | translate }}
                    </h4>
                </div>
                <div class="widget-content">
                    <p class="widget-text">
                        {{'SOLUTION6.FEATURE_2_SHORT_TEXT' | translate }}
                    </p>
                    <div class="features-btn-wrapper">
                        <a (click)="scrollToFeature(2)" target="_blank" class="features-btn">
                            <i class="lni lni-arrow-right"></i>
                            {{'SOLUTION_GENERAL.DETAILS' | translate }}
                        </a>
                    </div>
                </div>
            </div>

            <div class="feature-widget">
                <div class="widget-header">
                    <div class="widget-icon">
                        <i class="lni lni-cog"></i>
                    </div>
                    <h4 class="widget-title">
                        {{'SOLUTION6.FEATURE_3_SHORT_TITLE' | translate }}
                    </h4>
                </div>
                <div class="widget-content">
                    <p class="widget-text">
                        {{'SOLUTION6.FEATURE_3_SHORT_TEXT' | translate }}
                    </p>
                    <div class="features-btn-wrapper">
                        <a (click)="scrollToFeature(3)" target="_blank" class="features-btn">
                            <i class="lni lni-arrow-right"></i>
                            {{'SOLUTION_GENERAL.DETAILS' | translate }}
                        </a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>

<section #feature1 id="feature1" class="gray-area">
    <div class="container">
        <div class="row">

            <div class="col-12">
                <div class="right">
                    <h1 i18n="@@featureAutomaticAccountancyTitle" class="features-title left ">
                        {{'SOLUTION6.FEATURE_1_LONG_TITLE' | translate }}
                    </h1>
                    <p i18n="@@featureAutomaticAccountancyText" class="text grey text-16">
                        {{'SOLUTION6.FEATURE_1_LONG_INTRO' |
                        translate }} </p>
                </div>
            </div>

            <div class="col-lg-5 features-image left">
                <img src="assets/images/marketing/Lease-Automation.svg" alt="Hero">
            </div>

            <div class="col-lg-7 vertical-align-content">
                <div class="left">

                    <p i18n="@@featureAutomaticLatePaymentsText" class="text grey text-16">
                        <b> {{'SOLUTION6.FEATURE_1_LONG_TEXT_PARAGRAPH_1_TITLE' | translate }} </b>
                        {{'SOLUTION6.FEATURE_1_LONG_TEXT_PARAGRAPH_1_TEXT' | translate
                        }}
                    </p>

                    <p i18n="@@featureAutomaticLatePaymentsText" class="text grey text-16">
                        <b> {{'SOLUTION6.FEATURE_1_LONG_TEXT_PARAGRAPH_2_TITLE' | translate }} </b>
                        {{'SOLUTION6.FEATURE_1_LONG_TEXT_PARAGRAPH_2_TEXT' | translate
                        }}
                    </p>

                    <p i18n="@@featureAutomaticLatePaymentsText" class="text grey text-16">
                        <b> {{'SOLUTION6.FEATURE_1_LONG_TEXT_PARAGRAPH_3_TITLE' | translate }} </b>
                        {{'SOLUTION6.FEATURE_1_LONG_TEXT_PARAGRAPH_3_TEXT' | translate
                        }}
                    </p>

                    <p i18n="@@featureAutomaticLatePaymentsText" class="text grey text-16">
                        <b> {{'SOLUTION6.FEATURE_1_LONG_TEXT_PARAGRAPH_4_TITLE' | translate }} </b>
                        {{'SOLUTION6.FEATURE_1_LONG_TEXT_PARAGRAPH_4_TEXT' | translate
                        }}
                    </p>

                    <p i18n="@@featureAutomaticLatePaymentsText" class="text grey text-16">
                        <b> {{'SOLUTION6.FEATURE_1_LONG_TEXT_PARAGRAPH_5_TITLE' | translate }} </b>
                        {{'SOLUTION6.FEATURE_1_LONG_TEXT_PARAGRAPH_5_TEXT' | translate
                        }}
                    </p>

                </div>
            </div>

        </div>

        <div class="section-footer mt-40">

            <div class="page-button">
                <div class="features-btn-wrapper">
                    <a href="https://propero.io/login" target="_blank" class="features-btn">
                        <i class="lni lni-arrow-right"></i>
                        {{'SOLUTION_GENERAL.CREATE_ACCOUNT' |
                        translate }}
                    </a>
                </div>
            </div>

        </div>
    </div>

</section>

<section #feature2 id="feature2" class="white-area">
    <div class="container">
        <div class="row">

            <div class="col-12">
                <div class="left">
                    <h1 i18n="@@featureAutomaticAccountancyTitle" class="features-title left">
                        {{'SOLUTION6.FEATURE_2_LONG_TITLE' | translate }}
                    </h1>
                    <p i18n="@@featureAutomaticAccountancyText" class="text grey text-16">
                        {{'SOLUTION6.FEATURE_2_LONG_INTRO' |
                        translate }} </p>
                </div>
            </div>

            <div class="col-5 features-image right">
                <img src="assets/images/marketing/Mobile-Management.svg" alt="Hero">
            </div>

            <div class="col-7 vertical-align-content">
                <div class="left">

                    <p class="text grey text-16">
                        <b> {{'SOLUTION6.FEATURE_1_LONG_TEXT_PARAGRAPH_1_TITLE' | translate }} </b>
                        {{'SOLUTION6.FEATURE_1_LONG_TEXT_PARAGRAPH_1_TEXT' | translate
                        }}
                    </p>

                    <p class="text grey text-16">
                        <b> {{'SOLUTION6.FEATURE_2_LONG_TEXT_PARAGRAPH_2_TITLE' | translate }} </b>
                        {{'SOLUTION6.FEATURE_2_LONG_TEXT_PARAGRAPH_2_TEXT' | translate
                        }}
                    </p>

                    <p class="text grey text-16">
                        <b> {{'SOLUTION6.FEATURE_2_LONG_TEXT_PARAGRAPH_3_TITLE' | translate }} </b>
                        {{'SOLUTION6.FEATURE_2_LONG_TEXT_PARAGRAPH_3_TEXT' | translate
                        }}
                    </p>

                    <p class="text grey text-16">
                        <b> {{'SOLUTION6.FEATURE_2_LONG_TEXT_PARAGRAPH_4_TITLE' | translate }} </b>
                        {{'SOLUTION6.FEATURE_2_LONG_TEXT_PARAGRAPH_4_TEXT' | translate
                        }}
                    </p>

                    <p class="text grey text-16">
                        <b> {{'SOLUTION6.FEATURE_2_LONG_TEXT_PARAGRAPH_5_TITLE' | translate }} </b>
                        {{'SOLUTION6.FEATURE_2_LONG_TEXT_PARAGRAPH_5_TEXT' | translate
                        }}
                    </p>

                </div>
            </div>

        </div>

        <div class="section-footer mt-40">

            <div class="page-button">
                <div class="features-btn-wrapper">
                    <a href="https://propero.io/login" target="_blank" class="features-btn">
                        <i class="lni lni-arrow-right"></i>
                        {{'SOLUTION_GENERAL.CREATE_ACCOUNT' |
                        translate }}
                    </a>
                </div>
            </div>

        </div>
    </div>
</section>

<section #feature3 id="feature3" class="gray-area">
    <div class="container">
        <div class="row">

            <div class="col-12">
                <div class="right">
                    <h1 i18n="@@featureAutomaticAccountancyTitle" class="features-title left ">
                        {{'SOLUTION6.FEATURE_3_LONG_TITLE' | translate }}
                    </h1>
                    <p i18n="@@featureAutomaticAccountancyText" class="text grey text-16">
                        {{'SOLUTION6.FEATURE_3_LONG_INTRO' |
                        translate }}
                    </p>
                </div>
            </div>

            <div class="col-lg-5 features-image">
                <img src="assets/images/marketing/Image-12-0.svg" alt="Hero">
            </div>

            <div class="col-lg-7 vertical-align-content">
                <div class="left">

                    <p class="text grey text-16">
                        <b> {{'SOLUTION6.FEATURE_3_LONG_TEXT_PARAGRAPH_1_TITLE' | translate }} </b>
                        {{'SOLUTION6.FEATURE_3_LONG_TEXT_PARAGRAPH_1_TEXT' | translate
                        }}
                    </p>

                    <p class="text grey text-16">
                        <b> {{'SOLUTION6.FEATURE_3_LONG_TEXT_PARAGRAPH_2_TITLE' | translate }} </b>
                        {{'SOLUTION6.FEATURE_3_LONG_TEXT_PARAGRAPH_2_TEXT' | translate
                        }}
                    </p>

                    <p class="text grey text-16">
                        <b> {{'SOLUTION6.FEATURE_3_LONG_TEXT_PARAGRAPH_3_TITLE' | translate }} </b>
                        {{'SOLUTION6.FEATURE_3_LONG_TEXT_PARAGRAPH_3_TEXT' | translate
                        }}
                    </p>

                    <p class="text grey text-16">
                        <b> {{'SOLUTION6.FEATURE_3_LONG_TEXT_PARAGRAPH_4_TITLE' | translate }} </b>
                        {{'SOLUTION6.FEATURE_3_LONG_TEXT_PARAGRAPH_4_TEXT' | translate
                        }}
                    </p>

                    <p class="text grey text-16">
                        <b> {{'SOLUTION6.FEATURE_3_LONG_TEXT_PARAGRAPH_5_TITLE' | translate }} </b>
                        {{'SOLUTION6.FEATURE_3_LONG_TEXT_PARAGRAPH_5_TEXT' | translate
                        }}
                    </p>

                </div>
            </div>

        </div>

        <div class="section-footer mt-40">

            <div class="page-button">
                <div class="features-btn-wrapper">
                    <a href="https://propero.io/login" target="_blank" class="features-btn">
                        <i class="lni lni-arrow-right"></i>
                        {{'SOLUTION_GENERAL.CREATE_ACCOUNT' |
                        translate }}
                    </a>
                </div>
            </div>

        </div>
    </div>
</section>

<section id="faq" class="faq-area white-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="section-title text-center pb-30">
                    <h3 class="title">{{ 'SOLUTION6.QA_TITLE' | translate }}</h3>
                    <p class="text">{{ 'SOLUTION6.QA_TEXT' | translate }}</p>
                </div>
            </div>
        </div>

        <div class="faq-accordion">
            <div class="accordion" id="accordionExample">
                <div class="card">
                    <div class="card-header" id="headingOne">
                        <a i18n="@@question1Text" href="#" class="collapsed" data-toggle="collapse"
                            data-target="#collapseOne" aria-expanded="false"
                            aria-controls="collapseOne">{{'SOLUTION6.QUESTION_1' | translate }}</a>
                    </div>
                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                        <div class="card-body">
                            <p i18n="@@question1Answer" class="text">{{'SOLUTION6.QUESTION_1_ANSWER' | translate }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingTwo">
                        <a i18n="@@question2Text" href="#" class="collapsed" data-toggle="collapse"
                            data-target="#collapseTwo" aria-expanded="false"
                            aria-controls="collapseTwo">{{'SOLUTION6.QUESTION_2' | translate }}</a>
                    </div>
                    <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                        <div class="card-body">
                            <p i18n="@@question2Answer" class="text">{{'SOLUTION6.QUESTION_2_ANSWER' | translate }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingThree">
                        <a i18n="@@question3Text" href="#" class="collapsed" data-toggle="collapse"
                            data-target="#collapseThree" aria-expanded="false"
                            aria-controls="collapseThree">{{'SOLUTION6.QUESTION_3' | translate }}</a>
                    </div>
                    <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                        data-parent="#accordionExample">
                        <div class="card-body">
                            <p i18n="@@question2Answer" class="text">{{'SOLUTION6.QUESTION_3_ANSWER' | translate }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingFour">
                        <a i18n="@@question2Text" href="#" class="collapsed" data-toggle="collapse"
                            data-target="#collapseFour" aria-expanded="false"
                            aria-controls="collapseFour">{{'SOLUTION6.QUESTION_4' | translate }}</a>
                    </div>
                    <div id="collapseFour" class="collapse" aria-labelledby="headingFour"
                        data-parent="#accordionExample">
                        <div class="card-body">
                            <p i18n="@@question2Answer" class="text">{{'SOLUTION6.QUESTION_4_ANSWER' | translate }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingFive">
                        <a i18n="@@question2Text" href="#" class="collapsed" data-toggle="collapse"
                            data-target="#collapseFive" aria-expanded="false"
                            aria-controls="collapseFive">{{'SOLUTION6.QUESTION_5' | translate }}</a>
                    </div>
                    <div id="collapseFive" class="collapse" aria-labelledby="headingFive"
                        data-parent="#accordionExample">
                        <div class="card-body">
                            <p i18n="@@question2Answer" class="text">{{'SOLUTION6.QUESTION_5_ANSWER' | translate }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="contact" class="contact-area grey-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="section-title text-center pb-30">
                    <h3 class="title">{{ 'HOME.SECTION_CONTACTUS_TITLE' | translate }}</h3>
                    <p class="text">{{ 'HOME.SECTION_CONTACTUS_TEXT' | translate }}</p>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="contact-wrapper">
                    <h4 class="contact-title">
                        <i class="lni lni-envelope"></i>
                        {{ 'HOME.TEXT_MESSAGE' | translate }}
                    </h4>
                    <form #contactForm="ngForm" (ngSubmit)="send()">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-input">
                                    <label>{{ 'HOME.NAME' | translate }}</label>
                                    <div class="input-items">
                                        <input type="text" name="name" placeholder="{{ 'HOME.NAME' | translate }}"
                                            [(ngModel)]="contactItem.subject" required>
                                        <i class="lni lni-user"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-input">
                                    <label>{{ 'HOME.EMAIL' | translate }}</label>
                                    <div class="input-items">
                                        <input type="email" name="email" placeholder="{{ 'HOME.EMAIL' | translate }}"
                                            [(ngModel)]="contactItem.email" required email>
                                        <i class="lni lni-envelope"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-input">
                                    <label>{{ 'HOME.MESSAGE' | translate }}</label>
                                    <div class="input-items textarea">
                                        <textarea name="message" placeholder="{{ 'HOME.MESSAGE' | translate }}"
                                            [(ngModel)]="contactItem.content" required></textarea>
                                        <i class="lni lni-pencil-alt"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="text-center">
                                    <button 
                                        type="submit"
                                        class="features-btn" 
                                        [disabled]="contactForm.invalid || isLoading"
                                        [ngClass]="{'loading': isLoading}"
                                    >
                                        <span *ngIf="!isLoading">{{ 'HOME.SEND' | translate }}</span>
                                        <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>